import { OrderTypes } from '@/constants';

type UserName = {
  first?: string | null;
  last?: string | null;
};

type ResourceSet = {
  resourceType?: string;
  count?: number | null;
};

export const activeTab = {
  users: 'users',
  administrators: 'administrators',
  accessGroups: 'accessGroups',
};

export const tabs = [
  { tab: activeTab.users, title: 'Users' },
  { tab: activeTab.administrators, title: 'Administrators' },
  { tab: activeTab.accessGroups, title: 'Access groups' },
];

export const queryParamsInitial = {
  page: 1,
  pageSize: 10,
  filters: [] as Array<{ id: string; value?: string }>,
  sortKey: 'id',
  sortDirection: OrderTypes.Desc,
  tab: activeTab.users,
  deletedAt: null as boolean | string | null,
  isShowDeletedItems: false,
};

export const usersInstructionTypeForFilter = {
  filterId: 'array',
  filterEmail: 'string',
};

export const administratorsInstructionTypeForFilter = {
  filterPartnerClientAccountEmployee: 'string',
};

export const administratorsQueryParamsInitial = {
  ...queryParamsInitial,
  sortKey: 'partnerClientAccountEmployeeId',
  tab: activeTab.administrators,
};

export const accessGroupsInstructionTypeForFilter = {
  filterId: 'number',
  filterName: 'string',
  filterRole: 'string',
};

export const groupRoleSelectOptions = [
  { value: 'ENGINEER', label: 'Engineer' },
  { value: 'READ_ONLY', label: 'Read only' },
];

export const statusStateEnum: Record<string, string> = {
  ACTIVE: 'Active',
  WAIT_ACCEPT: 'Wait accept',
  DELETED: 'Deleted',
};

export const AccessGroupResourceType = {
  DnsAcl: 'DNS_ACL',
  DnsRemote: 'DNS_REMOTE',
  DnsResource: 'DNS_RESOURCE',
  L3MonitoringObject: 'L3_MONITORING_OBJECT',
  L3ProtectedProfile: 'L3_PROTECTED_PROFILE',
  L7Resource: 'L7_RESOURCE',
};

export const formatUserFullName = (name?: UserName | null): string => {
  if (!name) {
    return '';
  }

  return [name.first, name.last].filter(Boolean).join(' ');
};

export const getUserStatusLabel = (
  status?: string | null,
  deletedAt?: string | Date | null
): string => {
  if (deletedAt != null && deletedAt !== '') {
    return statusStateEnum.DELETED;
  }

  return statusStateEnum[status ?? ''] ?? status ?? '';
};

export const getGroupRoleLabel = (role?: string | null): string =>
  groupRoleSelectOptions.find((item) => item.value === role)?.label ?? role ?? '-';

export const getGroupRoleSelectOption = (role?: string | null) =>
  groupRoleSelectOptions.find((item) => item.value === role) ?? null;

export const formatResourceSets = (resourceSets?: ResourceSet[] | null): string => {
  if (!resourceSets?.length) {
    return '-';
  }

  return resourceSets.map(({ resourceType, count }) => `${resourceType}: ${count ?? 0}`).join(', ');
};

export const initialDeletedMemberState = {
  deleted: false,
  id: null as number | null,
  email: '',
};
